<header class="app-header">
  <div class="user-info">
    <span class="user-name">{{ userName }}</span>

    <!-- Botón de menú de usuario con Material -->
    <button
      mat-icon-button
      [matMenuTriggerFor]="userMenu"
      class="user-menu-button"
      aria-label="Menú de usuario"
    >
      <mat-icon>account_circle</mat-icon>
    </button>

    <!-- Menú desplegable -->
    <mat-menu #userMenu="matMenu" xPosition="before">
      <div class="user-menu-header">
        <mat-icon>person</mat-icon>
        <div class="user-details">
          <strong>{{ userName }}</strong>
          <small>{{ userRuc }}</small>
        </div>
      </div>

      <mat-divider></mat-divider>

      <button mat-menu-item (click)="viewProfile()">
        <mat-icon>badge</mat-icon>
        <span>Mi Perfil</span>
      </button>

      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Cerrar Sesión</span>
      </button>
    </mat-menu>
  </div>
</header>